// libs
import { memo, useCallback, useEffect } from 'react';
import { useWishlistContext } from 'shared/layouts/Wishlist/API/context';

// helpers
import { onPageLoad } from './helpers';

interface IAnalyticsProps {
  totalCount: number;
  products: Listing.IProduct[];
  isPriceDropStrip?: boolean;
  isPriceRevealEnabled: boolean;
  isSalePriceLiveEnabled: boolean;
}

function Analytics({
  totalCount,
  products,
  isPriceDropStrip = false,
  isPriceRevealEnabled,
  isSalePriceLiveEnabled,
}: IAnalyticsProps) {
  const { page, initialAPICalled } = useWishlistContext();

  const firePageLoad = useCallback(() => {
    if (page === 1) {
      onPageLoad({
        totalCount,
        products,
        isPriceDropStrip,
        isPriceRevealEnabled,
        isSalePriceLiveEnabled,
      });
    }
  }, [isPriceDropStrip, isPriceRevealEnabled, isSalePriceLiveEnabled, page, products, totalCount]);

  useEffect(() => {
    if (initialAPICalled) firePageLoad();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialAPICalled]);
  return null;
}

export default memo(Analytics);
